import Player from './Player';

class Team {
    players = [];

    currentScore = 0;

    currentGames = 0;

    constructor(players = []) {
        this.players = players.map((item) => new Player(item));
    }
}

export default Team;